const universitiesData = [
    {
      id: "uni1a7b9",
      name: "University of Ghana",
      courses: [
        { id: "course1b7f2", name: "Computer Science" },
        { id: "course2a5d9", name: "Business Administration" },
        { id: "course3c2e1", name: "Economics" },
        { id: "course4d6f4", name: "Law" }
      ]
    },
    {
      id: "uni2c8f3",
      name: "Kwame Nkrumah University of Science and Technology (KNUST)",
      courses: [
        { id: "course1e3f9", name: "Mechanical Engineering" },
        { id: "course2g6b2", name: "Architecture" },
        { id: "course3h7c8", name: "Pharmacy" },
        { id: "course4i9e1", name: "Computer Engineering" }
      ]
    },
    {
      id: "uni3d4h1",
      name: "University of Cape Coast",
      courses: [
        { id: "course1j8f2", name: "Education" },
        { id: "course2k2b7", name: "Nursing" },
        { id: "course3l6e3", name: "Mathematics" },
        { id: "course4m7c9", name: "Accounting" }
      ]
    },
    {
      id: "uni4e2b5",
      name: "Ashesi University",
      courses: [
        { id: "course1n9f1", name: "Business Administration" },
        { id: "course2o3d6", name: "Computer Science" },
        { id: "course3p4e7", name: "Engineering" },
        { id: "course4q5f3", name: "Management Information Systems" }
      ]
    },
    {
      id: "uni5f3h2",
      name: "University for Development Studies",
      courses: [
        { id: "course1r7g4", name: "Agricultural Science" },
        { id: "course2s5e1", name: "Development Planning" },
        { id: "course3t6b9", name: "Environmental Science" },
        { id: "course4u8c2", name: "Public Health" }
      ]
    }
  ];
  
  export default universitiesData;
  